/* eslint-disable no-unused-vars */

import axios from "axios";

export default {
    getHashData(hash, addtocart = 0) {
        //get config from hash
        let returnData;
        axios({
            method: "get",
            url: this.SWURL + '/widgets/SwagCustomProducts/getConfiguration?hash=' + hash,
        })
            .then(response => {
                returnData = response.data.configuration;
                if(addtocart === 1 && this.selectedProductNumber) {
                    let productID = this.selectedProductNumber;
                    this.saveForCartConfig();
                }
            })
            .catch(error => {
                console.log(error);
            });
    },
    saveForCartConfig() {
        //post to shopping cart
        let selectedSteps = this.stepperSteps;
        let setCartArray = new Map();
        let productId;
        let productNumber;
        let templateId;

        selectedSteps.forEach(function (item) {
            //later uitbreiden met .items achter accordion
            if(item.number < 2) {
                //productNumber
                item.accordion.forEach(function (acc) {
                    acc.items.forEach(function (option) {
                        if(option.type === 'radio-subcat-hoogte') {
                            productId = option.value;
                            option.options.forEach(function (getartcl) {
                                if(getartcl.value === productId) {
                                    productNumber = getartcl.productNumber;
                                }
                            });
                        }
                    });
                });
                return;
            }
            item.accordion.forEach(function (acc) {
                acc.items.forEach(function (option) {
                    if(!option.value || !option.id) {
                        return;
                    }
                    else {
                        setCartArray.set(option.id, option.value);
                    }
                    if(option.template_id) {
                        templateId = option.template_id;
                    }
                });
            });
        });
        var formData = new FormData();

        for (let [key, value] of setCartArray) {
            formData.append('custom-option-id--' + key, value);
        }
        // // formData.append('sArticle', productId);
        formData.append('templateId', templateId);
        formData.append('number', this.selectedProductNumber);
        // // formData.append('sQuantity', '1');

        this.getHash(formData, productNumber);
        // this.$emit('clickOnCartAdd')
    },
    onCartAdd() {
        if(!this.currentHash) {
            this.saveConfig();
        }
        else {
            this.getHashData(this.currentHash, 1);
        }
    },
    saveConfig() {
        let thisVar = this;
        //post to shopping cart
        let selectedSteps = this.stepperSteps;
        let setCartArray = new Map();
        let productId;
        let productNumber;
        let templateId;

        selectedSteps.forEach(function (item) {
            //later uitbreiden met .items achter accordion
            if(item.number < 2) {
                //productNumber
                item.accordion.forEach(function (acc) {
                    acc.items.forEach(function (option) {
                        if(option.type === 'radio-subcat-hoogte') {
                            productId = option.value;
                            option.options.forEach(function (getartcl) {
                                if(getartcl.value === productId) {
                                    productNumber = getartcl.productNumber;
                                }
                            });
                        }
                    });
                });
                return;
            }
            item.accordion.forEach(function (acc) {
                acc.items.forEach(function (option) {
                    if(!option.value || !option.id) {
                        return;
                    }
                    else {
                        setCartArray.set(option.id, option.value);
                    }
                    if(option.template_id) {
                        templateId = option.template_id;
                    }
                });
            });
        });
        var formData = new FormData();

        for (let [key, value] of setCartArray) {
            formData.append('custom-option-id--' + key, value);
        }
        //set hash in default vars
        this.saveHash(formData, productNumber, productId);
        // this.snackbar = true;
    },
    saveHash(data, productNumber, sArticle) {
        let returnHash;
        let appendUrl ='?sArticle='+sArticle+'&number='+productNumber+'&sQuantity=1';
        axios({
            method: "post",
            url: this.SWURL + '/widgets/SwagCustomProducts/overviewCalculation' + appendUrl,
            data: data
        })
            .then(response => {
                returnHash = response.data.hash;
                this.currentHash = returnHash;
                // console.info (returnHash);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getHash(data, productNumber) {
        let setHash;
        let setNumber = productNumber;
        // for debug;
        // // Display the key/value pairs in log
        // // -----------------------------------
        // for (var pair of data.entries()) {
        //     console.log(pair[0]+ ', ' + pair[1]);
        // }
        // // -----------------------------------
        axios({
            method: "post",
            url: this.SWURL + '/widgets/SwagCustomProducts/saveConfiguration',
            data: data,
        })
            .then(response => {
                setHash = response.data.hash;
                this.cartHash(setHash, setNumber);
            })
            .catch(error => {
                console.log(error);
            });
    },
    cartHash(hash, number) {
        let thisVar = this;
        let setHash = hash;
        let setNumber = number;
        let setCsrf = '';
        // eslint-disable-next-line no-undef
        setCsrf = CSRF.getToken();

        let formData = new FormData();
        formData.append('sActionIdentifier', '');
        formData.append('sAddAccessories', '');
        formData.append('sAdd', setNumber);
        formData.append('sQuantity', thisVar.addAmountToCart);
        formData.append('__csrf_token', setCsrf);
        formData.append('customProductsHash', setHash);
        formData.append('isXHR', '1');

        axios({
            method: "post",
            url: this.SWURL + '/checkout/ajaxAddArticleCart',
            data: formData
        })
            .then(response => {
                // console.log(response.data);
                // eslint-disable-next-line
                $.publish('plugin/swAddArticle/onAddArticle', 'cartRefresh');
                this.$emit('clickOnCartAdd');
                thisVar.onCartAddLoading = false;
                window.localStorage.removeItem('subLadeOpMaatCatInfo');
                window.localStorage.removeItem('subLadeOpMaatCat');
                window.localStorage.removeItem('catLadeOpMaatDetail');
                window.localStorage.removeItem('preSteps');
                window.localStorage.removeItem('steps');
                window.localStorage.removeItem('currentStep');
                window.localStorage.removeItem('totalprice');

                window.localStorage.removeItem('selectedBrand');
                window.localStorage.removeItem('step1HeightproductID');
                window.localStorage.removeItem('step1Height');
                window.localStorage.removeItem('step1TypeProductID');
                window.localStorage.removeItem('step1Type');
                window.localStorage.removeItem('step1Brand');
                window.localStorage.removeItem('step1productID');

                // Clear all option in step 1
                thisVar.clearOptions();
                thisVar.stepperSteps[0].accordion[1].value = '';
                thisVar.stepperSteps[0].accordion[1].items[0].value = '';
                thisVar.stepperSteps[0].accordion[1].items[0].selectedLabel = '';
                thisVar.stepperSteps[0].accordion[2].value = '';
                thisVar.stepperSteps[0].accordion[2].items[0].value = '';
                thisVar.stepperSteps[0].accordion[2].items[0].selectedLabel = '';

                thisVar.stepperSteps[0].accordion[2].value = '';
                thisVar.stepperSteps[0].accordion[2].items[0].value = '';
                thisVar.stepperSteps[0].accordion[2].items[0].selectedLabel = '';
                thisVar.addAmountToCart = '';
                document.querySelector('.cart--link').click();

            })
            .catch(error => {
                console.log(error);
            });
    },
}
/* eslint-enable no-unused-vars */
